import { sineInOut } from 'svelte/easing'
// Fra github.com/mattdesl/canvas-sketch-util
export function mapRange(value, inputMin, inputMax, outputMin, outputMax, clamp) {
  if (Math.abs(inputMin - inputMax) < Number.EPSILON) {
    return outputMin
  } else {
    var outVal = ((value - inputMin) / (inputMax - inputMin)) * (outputMax - outputMin) + outputMin
    if (clamp) {
      if (outputMax < outputMin) {
        if (outVal < outputMax) outVal = outputMax
        else if (outVal > outputMin) outVal = outputMin
      } else {
        if (outVal > outputMax) outVal = outputMax
        else if (outVal < outputMin) outVal = outputMin
      }
    }
    return outVal
  }
}

export function rotate(cx, cy, x, y, t) {
  if (t === 0) return [x, y]

  let cos = Math.cos(t),
    sin = Math.sin(t),
    nx = cos * (x - cx) - sin * (y - cy) + cx,
    ny = cos * (y - cy) + sin * (x - cx) + cy
  return [nx, ny]
}

export function degToRad(deg) {
  return (deg * Math.PI) / 180
}

export function oscillate(min, max, options) {
  const opts = {
    duration: 500,
    easing: sineInOut,
    ...options,
  }
  let from = min
  let to = max

  return function oscillator(t) {
    // 0=forward, 1=backwards
    const dir = Math.floor((t / opts.duration) % 2)
    const progress = (t % opts.duration) / opts.duration
    if (dir === 0) {
      from = min
      to = max
    } else if (dir === 1) {
      from = max
      to = min
    }

    return from + (to - from) * opts.easing(progress)
  }
}
